import React, { useState, useEffect } from 'react';
import axios from './axios';
import style from './PerformanceMonitor.module.css';
import { Tooltip } from '@blueprintjs/core';

function PerformanceMonitor() {
    
    const [time, setTime] = useState(-1);
    
    
    useEffect(()=>{
        setInterval(async ()=>{
            try {
                const response = await axios.head("/");
                setTime(response.time);
            } catch (err) {
                console.error(err);
                setTime(2000);
            }
        }, 5000);
    }, []);
    
    const colorStyle = (time < 200)? style.good : (time < 500)? style.medium : style.bad;
    
    const hoverContent = (
        <span className={style.hoverContainer + " " + colorStyle}>Ping {time}</span>
    );
    
    
    return (
            <Tooltip placement="top" content={hoverContent}>
                <div className={style.mainContainer}>
                    <div className={`${style.subContainer} ${colorStyle}`}>
                    </div>
                </div>
            </Tooltip>
    )
}

export default PerformanceMonitor;